import styled from "styled-components";

import { Container } from "../DomainInstruction/DomainInstruction.style";

export const ConnectConstruction = styled(Container)`
    height: 100%;
`